import { ASSET_TYPES } from '@/services/AssetService/config';
import Env from '@/helpers/Env';
import { getUrlFloat, getUrlBoolean, getUrlString } from '@/helpers/UrlParam';

// **********************************************************************
// URLS
// **********************************************************************
export const fonts = {};

export const models = {};

export const images = {};

export const textures = {
  t_corn1: `assets/textures-o/area2/corn1.ktx2`,
  t_dog1: `assets/textures-o/area2/dog1.ktx2`,
  t_dog2: `assets/textures-o/area2/dog2.ktx2`,
  t_poo: `assets/textures-o/area2/poo.ktx2`,
  t_scarecrow: `assets/textures-o/area2/scarecrow.ktx2`,
  t_tractor: `assets/textures-o/area2/tractor.ktx2`,

  t_score_2: `assets/textures-o/area2/score_2.ktx2`,
};

export const jsons = {};

export const sounds = {};

const videos = {};

export const urls = {
  ...fonts,
  ...models,
  ...images,
  ...textures,
  ...sounds,
  ...videos,
};

// **********************************************************************
// MANIFEST
// **********************************************************************
export const manifest = {
  id: 'tractor',
  items: [
    ...Object.entries(fonts).map(([id, url]) => ({ id, url })),
    ...Object.entries(models).map(([id, url]) => ({ id, url })),
    ...Object.entries(images).map(([id, url]) => ({ id, url })),
    ...Object.entries(textures).map(([id, url]) => ({ id, url })),
    ...Object.entries(sounds).map(([id, url]) => ({ id, url })),
    ...Object.entries(jsons).map(([id, url]) => ({ id, url })),
    ...Object.entries(videos).map(([id, url]) => ({ id, url })),
  ],
};
